const routes = [
  {
    path: '/qingbaijiang/1',
    name: 'qingbaijiang1',
    meta: {
      title: '《成都市青白江区“企业专项奖学金”奖励申报指南》实施办法政策解读与引导'
    },
    component: () => import('./1.vue')
  },
  {
    path: '/qingbaijiang/2',
    name: 'qingbaijiang2',
    meta: {
      title: '《成都市青白江区“引才伯乐奖”申报指南》实施办法政策解读与引导'
    },
    component: () => import('./2.vue')
  },
  {
    path: '/qingbaijiang/3',
    name: 'qingbaijiang3',
    meta: {
      title: '《成都市青白江区中试产业领军人才奖励申报指南》实施办法政策解读与引导'
    },
    component: () => import('./3.vue')
  },
]

export default routes